export default {
  clearState: function() {
    sessionStorage.clear();
  },
  getState: function(key) {
    return sessionStorage.getItem(key);
  },
  setState: function(key, value) {
    sessionStorage.setItem(key, value);
  }
};



// WEBPACK FOOTER //
// ./src/resources/state.js